import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for login
export const login = createAsyncThunk('upstoxAuth/login', async (upstoxToken) => {
  console.log("login");
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/upstox/auth`, {
    method: 'GET',
    withCredentials: true
  });
  console.log("response", response.data);
  if (response.data.authUrl) {
    // Store the state in localStorage
    localStorage.setItem('upstoxState', response.data.state);
    window.open(response.data.authUrl, '_blank');
  }
  return { ...response.data, upstoxToken };
});

export const handleUpstoxCallback = createAsyncThunk('upstoxAuth/handleUpstoxCallback', async (code) => {
  const state = localStorage.getItem('upstoxState');
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/upstox/code`, {
    params: { code, state }
  });
  console.log("response", response.data);
  // Clear the state after use
  localStorage.removeItem('upstoxState');
  return response.data;
});

// Add new thunk for token generation
export const generateToken = createAsyncThunk('upstoxAuth/generateToken', async (clientSecret) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/upstox/generate-token`, {
      client_secret: clientSecret
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
});

// Request token thunk
export const requestToken = createAsyncThunk(
    'upstoxAuth/requestToken',
    async ({ client_id, client_secret }) => {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/upstox/token/request/${client_id}`,
            { client_secret }
        );
        return response.data;
    }
);

// Check token request status thunk
export const checkTokenRequestStatus = createAsyncThunk(
    'upstoxAuth/checkTokenRequestStatus',
    async (request_id) => {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/upstox/token/status/${request_id}`
        );
        return response.data;
    }
);

// Selector to get upstoxToken


// Auth slice
const upstoxAuthSlice = createSlice({
  name: 'upstoxAuth',
  initialState: {
    upstoxToken: localStorage.getItem('upstoxToken') || '',
    isAuthenticated: !!localStorage.getItem('upstoxToken'),
    status: 'idle',
    error: null,
  },
  reducers: {
    logout(state) {
      localStorage.removeItem('upstoxToken');
      localStorage.removeItem('upstoxState');
      state.upstoxToken = '';
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.upstoxToken = action.payload.upstoxToken;
        state.isAuthenticated = true;
        state.status = 'succeeded';
        localStorage.setItem('upstoxToken', action.payload.upstoxToken);
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(handleUpstoxCallback.fulfilled, (state, action) => {
        localStorage.setItem('upstoxToken', action.payload.access_token);
        state.upstoxToken = action.payload.access_token;
        state.isAuthenticated = true;
        console.log("upstoxToken", action.payload.access_token);
      })
      .addCase(handleUpstoxCallback.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(generateToken.fulfilled, (state, action) => {
        if (action.payload.data?.access_token) {
          state.upstoxToken = action.payload.data.access_token;
          state.isAuthenticated = true;
          localStorage.setItem('upstoxToken', action.payload.data.access_token);
        }
      })
      .addCase(generateToken.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(requestToken.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(requestToken.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.pendingRequest = action.payload.data;
      })
      .addCase(requestToken.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(checkTokenRequestStatus.fulfilled, (state, action) => {
        if (action.payload.data.status === 'completed') {
          state.isAuthenticated = true;
          state.status = 'succeeded';
        }
      });
  },
});

export const { logout } = upstoxAuthSlice.actions;
export default upstoxAuthSlice.reducer;
